import { registerBlock } from '../../core/registry.js';
import { ColumnsCanvas, ColumnsInspector, ColumnCanvas, ColumnInspector } from './Canvas.jsx';

const columnsDefinition = {
  type: 'columns',
  schema: {
    defaults: () => ({ gap: 16 }),
  },
  capabilities: {
    isContainer: true,
    allowedChildren: ['column'], // only column blocks
  },
  ui: {
    Canvas: ColumnsCanvas,
    Inspector: ColumnsInspector,
    icon: '🗃️',
    label: 'Columns',
    keywords: ['columns', 'grid', 'layout', 'side by side'],
  },
  serialize: (attrs, innerHtml, children) => {
    const gap = attrs.gap || 16;
    // Use the number of actual column children for the grid template
    const colCount = Array.isArray(children) ? children.length : 2;
    const cols = Array(Math.max(1, colCount)).fill('1fr').join(' ');
    return `<div style="display:grid;grid-template-columns:${cols};gap:${gap}px">${innerHtml}</div>`;
  },
};

const columnDefinition = {
  type: 'column',
  schema: {
    defaults: () => ({}),
  },
  capabilities: {
    isContainer: true,
    allowedChildren: (type) => type !== 'column' && type !== 'columns',
    canDropInto: (parentType) => parentType === 'columns',
  },
  ui: {
    Canvas: ColumnCanvas,
    Inspector: ColumnInspector,
    icon: '▭',
    label: 'Column',
    keywords: ['column', 'cell'],
  },
  serialize: (_attrs, innerHtml) => `<div>${innerHtml}</div>`,
};

registerBlock(columnsDefinition);
registerBlock(columnDefinition);

export default { columnsDefinition, columnDefinition };
